import { FAQItem } from '../types';

export const reserve2010FaqItems: FAQItem[] = [
  {
    id: 'r2010-faq-move-adjacent',
    question: 'Czy ruch po skosie jest darmowy?',
    answer: 'Tak. Sąsiedztwo obejmuje pola ortogonalne i diagonalne.',
    tags: ['ruch'],
    chapterId: 'r2010-movement',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-stay',
    question: 'Czy mogę zostać na tym samym polu Quadrelu?',
    answer: 'Nie, musisz się przenieść. Wyjątek: Pass/Press Release, gdy nie możesz wykonać innej akcji.',
    tags: ['ruch'],
    chapterId: 'r2010-movement',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-pass-cost',
    question: 'Czy płacę za wejście na Pass, gdy stoi tam ktoś?',
    answer: 'Nie. Wejście na Pass/Press Release jest zawsze darmowe.',
    tags: ['ruch', 'pass'],
    chapterId: 'r2010-movement',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-tax-marker',
    question: 'Kiedy płacę za znacznik Year/Taxation?',
    answer: 'Gdy wchodzisz na pole, na którym stoi ten znacznik — +1 Bago do banku (oprócz innych kosztów).',
    tags: ['ruch'],
    chapterId: 'r2010-movement',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-two-actions',
    question: 'Ile głównych akcji mam w roku?',
    answer: 'Dokładnie dwie. Korzyści magnatów ich nie zastępują.',
    tags: ['akcje'],
    chapterId: 'r2010-year-structure',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-vineyard-same',
    question: 'Czy w jednej akcji kupię 2 winnice z jednego regionu?',
    answer: 'Nie. Jedna akcja Winnice nigdy nie pozwala na 2 winnice z tego samego regionu.',
    tags: ['winnice'],
    chapterId: 'r2010-vineyards',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-winery-cost',
    question: 'Ile kosztuje winiarnia?',
    answer: '3 Bagos za każdą; możesz zbudować 1 lub 2 w akcji.',
    tags: ['winiarnie'],
    chapterId: 'r2010-wineries',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-cellar-cost',
    question: 'Ile kosztuje piwnica?',
    answer: '2 Bagos; budujesz jedną na akcję i przenosisz wina z magazynu z zachowaniem starzenia.',
    tags: ['piwnice'],
    chapterId: 'r2010-cellars-aging',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-bank-withdraw',
    question: 'Co się dzieje na polu −2 VP konta?',
    answer: 'Natychmiast tracisz 2 VP i nie możesz dalej wypłacać, dopóki konto nie pójdzie do przodu. Ponowna strata tylko przy ponownym wejściu na to pole.',
    tags: ['bank'],
    chapterId: 'r2010-bank',
    group: 'Bank',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-bank-interest-cash',
    question: 'Czy odsetki mogę wziąć gotówką?',
    answer: 'Nie. Odsetki i pensje rozliczasz wyłącznie znacznikiem konta.',
    tags: ['bank', 'utrzymanie'],
    chapterId: 'r2010-bank',
    group: 'Bank',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-divest',
    question: 'Kiedy mogę divestować?',
    answer: 'W dowolnym momencie gry, przesuwając inwestycję w lewo i biorąc gotówkę z dolnej ikony.',
    tags: ['bank'],
    chapterId: 'r2010-bank',
    group: 'Bank',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-invest-max',
    question: 'Jaki jest limit inwestycji?',
    answer: 'Znacznik inwestycji nie idzie dalej niż +3 (i nie poniżej −2 przy divest).',
    tags: ['bank'],
    chapterId: 'r2010-bank',
    group: 'Bank',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-quality-formula',
    question: 'Jak liczyć jakość wina?',
    answer: '+2/winnica +1/farmer +1/winiarnia +2/enolog +3 Porto (tylko Douro) ± pogoda. Jakość 0 = brak kafla.',
    tags: ['produkcja'],
    chapterId: 'r2010-wine-quality',
    group: 'Produkcja i pogoda',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-weather',
    question: 'Kiedy działa pogoda z rocznika?',
    answer: 'Przy produkcji na końcu tego samego roku, którego dotyczy odkryty kafel.',
    tags: ['rocznik'],
    chapterId: 'r2010-start-of-year',
    group: 'Produkcja i pogoda',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-porto',
    question: 'Kiedy mogę wydać Porto?',
    answer: 'W produkcji, tylko aby podnieść jakość wina z Douro o +3.',
    tags: ['douro', 'porto'],
    chapterId: 'r2010-regions',
    group: 'Produkcja i pogoda',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-age-lost',
    question: 'Co z winem na ostatnim polu?',
    answer: 'Przy starzeniu, jeśli nie ma pola dalej, wino jest tracone i odrzucane.',
    tags: ['starzenie'],
    chapterId: 'r2010-cellars-aging',
    group: 'Starzenie',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-age-order',
    question: 'Najpierw starzenie czy produkcja?',
    answer: 'Najpierw starzenie (i przestawienie pracowników), potem produkcja nowych win.',
    tags: ['produkcja'],
    chapterId: 'r2010-production',
    group: 'Starzenie',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-sales-account',
    question: 'Czy przy sprzedaży przesuwam konto o wartość wina?',
    answer: 'Nie — o liczbę pól wskazaną na slocie sprzedaży, niezależnie od dokładnej wartości wina.',
    tags: ['sprzedaż'],
    chapterId: 'r2010-sales',
    group: 'Sprzedaż i eksport',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-sales-pair',
    question: 'Czy mogę odzyskać jedną beczkę ze sprzedaży?',
    answer: 'Nie. Tylko pary z tego samego lokalu; za parę kładziesz 2 renomy w różnych regionach.',
    tags: ['sprzedaż'],
    chapterId: 'r2010-sales',
    group: 'Sprzedaż i eksport',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-renown-spite',
    question: 'Czy mogę zdjąć renomę bez potrzeby?',
    answer: 'Nie. Renomy wolno użyć tylko gdy są potrzebne do osiągnięcia progu.',
    tags: ['renoma'],
    chapterId: 'r2010-wine-quality',
    group: 'Renoma',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-renown-who',
    question: 'Czy tylko ja korzystam z renomy, którą położyłem?',
    answer: 'Nie. Każdy z Region Markerem w regionie może użyć kostek z wcięcia.',
    tags: ['renoma'],
    chapterId: 'r2010-wine-quality',
    group: 'Renoma',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-alentejo',
    question: 'Ile daje renoma Alentejo?',
    answer: 'Każda użyta kostka +2 do wartości (nadal max 2 kostki: +2 lub +4).',
    tags: ['renoma'],
    chapterId: 'r2010-regions',
    group: 'Renoma',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-export-vp',
    question: 'Skąd biorą się VP za eksport?',
    answer: 'Natychmiast z wiersza slotu. Na końcu gry dodatkowo większości kolumn.',
    tags: ['eksport'],
    chapterId: 'r2010-export',
    group: 'Sprzedaż i eksport',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-export-2p',
    question: 'Co z eksportem przy 2 graczach?',
    answer: 'Dostępne są tylko sloty w ramce 2-graczy.',
    tags: ['eksport'],
    chapterId: 'r2010-export',
    group: 'Sprzedaż i eksport',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-fair-points-vp',
    question: 'Czy Fair Points to VP?',
    answer: 'Nie. FP budują ranking; VP z targów zależą od miejsca w rankingu według tabeli.',
    tags: ['targi'],
    chapterId: 'r2010-wine-fairs',
    group: 'Targi',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-fair-reset',
    question: 'Czy FP zerują się po targach?',
    answer: 'Nie. Sumują się przez całą grę.',
    tags: ['targi'],
    chapterId: 'r2010-wine-fairs',
    group: 'Targi',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-press-once',
    question: 'Ile razy mogę zrobić Press Release na te targi?',
    answer: 'Raz. Późniejsze wizyty na polu to Pass (ze zmianą kolejności).',
    tags: ['targi'],
    chapterId: 'r2010-press-release',
    group: 'Targi',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-magnate-year1',
    question: 'Czy w 1. roku kładę beczki na magnatach?',
    answer: 'Nie. Magnaci nie interesują się startupami w 1. roku.',
    tags: ['magnaci'],
    chapterId: 'r2010-press-release',
    group: 'Targi',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-magnate-benefit',
    question: 'Czy korzyść magnata zastępuje akcję?',
    answer: 'Nie. Odrzucasz wino i przenosisz beczkę, ale nadal musisz wykonać normalną akcję Quadrelu.',
    tags: ['magnaci'],
    chapterId: 'r2010-magnates',
    group: 'Targi',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-experts-limit',
    question: 'Ile ekspertów mogę mieć?',
    answer: 'Maksymalnie 6. Przy kolejnym najpierw odrzuć jednego.',
    tags: ['eksperci'],
    chapterId: 'r2010-experts',
    group: 'Eksperci',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-experts-many',
    question: 'Czy w turze użyję wielu ekspertów?',
    answer: 'Tak w Reserve 2010 — dowolną liczbę odkrytych, odwracając je. (W 2016 limit jest inny.)',
    tags: ['eksperci'],
    chapterId: 'r2010-experts',
    group: 'Eksperci',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-farmers',
    question: 'Jak zdobyć farmera bez Tasting Room?',
    answer: 'Przez posiadłość w Ribatejo (premia regionu / start).',
    tags: ['farmerzy'],
    chapterId: 'r2010-enologists',
    group: 'Ruch i akcje',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-maintenance-fire',
    question: 'Czy mogę zwolnić enologa mając pieniądze na koncie?',
    answer: 'Nie. Musisz płacić, dopóki stać Cię na pensje.',
    tags: ['utrzymanie'],
    chapterId: 'r2010-maintenance',
    group: 'Utrzymanie',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-end-bank',
    question: 'Czy gotówka w ręku daje VP na końcu?',
    answer: 'Nie bezpośrednio. Punktujesz saldo konta; gotówkę możesz wcześniej wpłacić lub uwzględnić przy niektórych mnożnikach po divest.',
    tags: ['punktacja'],
    chapterId: 'r2010-end-of-game',
    group: 'Punktowanie końcowe',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-tie',
    question: 'Jak rozstrzygnąć remis VP?',
    answer: 'Więcej beczek w eksporcie; potem więcej pieniędzy (gotówka + konto) po divest.',
    tags: ['remis'],
    chapterId: 'r2010-end-of-game',
    group: 'Punktowanie końcowe',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-estates-count',
    question: 'Ile posiadłości mam na planszetce?',
    answer: 'Cztery w Reserve 2010.',
    tags: ['posiadłości'],
    chapterId: 'r2010-board-overview',
    group: 'Różnice od 2016',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-mix-2016',
    question: 'Czy mogę użyć kafli magnatów z 2016?',
    answer: 'Nie. Reserve 2010 używa pól Additional Action/Multiplier na planszy 2010, nie talii Action/Multiplier z 2016.',
    tags: ['warianty'],
    chapterId: 'r2010-components',
    group: 'Różnice od 2016',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-faq-mod-experts',
    question: 'Czy Experts działa z Reserve 2010?',
    answer: 'Tak. Advertiser daje korzyść magnata bez wydawania wina.',
    tags: ['moduły', 'experts'],
    chapterId: 'r2010-module-experts',
    group: 'Moduły',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['experts'],
  },
  {
    id: 'r2010-faq-mod-islands',
    question: 'Czy Islands działa z Reserve 2010?',
    answer: 'Tak. Wyspy zastępują wyłączone regiony; przypisz numer Caroliny.',
    tags: ['moduły', 'islands'],
    chapterId: 'r2010-module-islands',
    group: 'Moduły',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['islands'],
  },
  {
    id: 'r2010-faq-mod-tasting',
    question: 'Czy Tasting Room zmienia farmerów w 2010?',
    answer: 'Tak — kafel Enolodzy/Farmerzy/Turyści stroną 2010 pozwala zatrudniać farmerów i turystów.',
    tags: ['moduły', 'tasting-room'],
    chapterId: 'r2010-module-tasting-room',
    group: 'Moduły',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['tasting-room'],
  },
  {
    id: 'r2010-faq-mod-connoisseur',
    question: 'Czy turysta wchodzi do podwójnej piwnicy?',
    answer: 'Nie. Podwójna piwnica Connoisseur jest niedostępna dla turystów.',
    tags: ['moduły', 'connoisseur'],
    chapterId: 'r2010-module-connoisseur',
    group: 'Moduły',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['tasting-room', 'connoisseur'],
  },
  {
    id: 'r2010-faq-feature-bottles',
    question: 'Do czego służą butelki cech z Tasting Room?',
    answer: 'Wyłącznie kosmetycznie w Reserve 2010 — zastępują znaczniki cech.',
    tags: ['moduły'],
    chapterId: 'r2010-module-tasting-room',
    group: 'Moduły',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['tasting-room'],
  },
];
